/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport, Locale } from '@typescript-kit/core';

import * as texts from '../text/device-de.text.json';

export const deviceDeLocale: Locale = {
  texts: getJsonExport(texts),
  formats: null
};
